import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { daysUntil } from "@/utils/datetime";
import { formatBytes } from "@/utils/format";
export function computeDashboardStats(mailboxes, backups, storage, now) {
    return {
        mailboxCount: mailboxes.length,
        activeCount: backups.filter((b) => b.status === "running" || b.status === "queued").length,
        failedCount: backups.filter((b) => b.status === "failed").length,
        sealedCount: backups.filter((b) => b.status === "sealed").length,
        expiringCount: backups.filter((b) => {
            if (!b.retention_until || b.status === "deleted")
                return false;
            const days = daysUntil(b.retention_until, now);
            return days !== null && days >= 0 && days <= 30;
        }).length,
        storageTotalBytes: storage
            ? Object.values(storage.per_backend).reduce((a, b) => a + b, 0)
            : 0,
    };
}
function StatCard({ label, value, sub, accent, }) {
    const valueCls = accent === "blue"
        ? "text-blue-600"
        : accent === "red"
            ? "text-red-600"
            : accent === "amber"
                ? "text-amber-600"
                : "text-slate-900";
    return (_jsxs("div", { className: "rounded-lg border border-slate-200 bg-white px-4 py-3", children: [_jsx("div", { className: "mb-1 text-[10px] font-medium uppercase tracking-wide text-slate-400", children: label }), _jsx("div", { className: `text-2xl font-bold ${valueCls}`, children: value }), _jsx("div", { className: "mt-0.5 text-[11px] text-slate-500", children: sub })] }));
}
export function StatCards({ stats }) {
    return (_jsxs("div", { className: "grid grid-cols-3 gap-4", children: [_jsx(StatCard, { label: "Mailboxuri", value: stats.mailboxCount, sub: "cu backup activ" }), _jsx(StatCard, { label: "Backup-uri active", value: stats.activeCount, sub: "running / queued", accent: stats.activeCount > 0 ? "blue" : undefined }), _jsx(StatCard, { label: "E\u0219uate", value: stats.failedCount, sub: "necesit\u0103 aten\u021Bie", accent: stats.failedCount > 0 ? "red" : undefined }), _jsx(StatCard, { label: "Storage", value: formatBytes(stats.storageTotalBytes), sub: "disk + cloud" }), _jsx(StatCard, { label: "Expir\u0103 cur\u00E2nd", value: stats.expiringCount, sub: "\u00EEn \u226430 zile", accent: stats.expiringCount > 0 ? "amber" : undefined }), _jsx(StatCard, { label: "Total backup-uri", value: stats.sealedCount, sub: "sealed \u00EEn sistem" })] }));
}
